module.exports = __webpack_public_path__ + "0800e1bcd739b7f75915622a2556b6ee.pdf";